import React from 'react';
export var SuccessIcon = function SuccessIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#7BDCAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7071 14.2929C28.0976 14.6834 28.0976 15.3166 27.7071 15.7071L17 26.4142L12.2929 21.7071C11.9024 21.3166 11.9024 20.6834 12.2929 20.2929C12.6834 19.9024 13.3166 19.9024 13.7071 20.2929L17 23.5858L26.2929 14.2929C26.6834 13.9024 27.3166 13.9024 27.7071 14.2929Z",
    fill: "#004120"
  }));
};
export var WarningIcon = function WarningIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#FAD08A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2691 10.994C19.0395 9.66346 20.9605 9.66345 21.7308 10.994L30.9964 26.9982C31.7683 28.3315 30.8062 30.0002 29.2655 30.0002H10.7344C9.19378 30.0002 8.23165 28.3315 9.00358 26.9982L18.2691 10.994ZM29.2655 28.0002L20 11.9961L10.7344 28.0002L29.2655 28.0002Z",
    fill: "#592D00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 26.0002H19V24.0002H21V26.0002Z",
    fill: "#592D00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 22.0002H19V17.0002H21V22.0002Z",
    fill: "#592D00"
  }));
};
export var ErrorIcon = function ErrorIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#F6A5AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7071 14.2929C15.3166 13.9024 14.6834 13.9024 14.2929 14.2929C13.9024 14.6834 13.9024 15.3166 14.2929 15.7071L18.5858 20L14.2929 24.2929C13.9024 24.6834 13.9024 25.3166 14.2929 25.7071C14.6834 26.0976 15.3166 26.0976 15.7071 25.7071L20 21.4142L24.2929 25.7071C24.6834 26.0976 25.3166 26.0976 25.7071 25.7071C26.0976 25.3166 26.0976 24.6834 25.7071 24.2929L21.4142 20L25.7071 15.7071C26.0976 15.3166 26.0976 14.6834 25.7071 14.2929C25.3166 13.9024 24.6834 13.9024 24.2929 14.2929L20 18.5858L15.7071 14.2929Z",
    fill: "#770018"
  }));
};